import { render, staticRenderFns } from "./documents-atas.vue?vue&type=template&id=5a9684f3&scoped=true"
import script from "./documents-atas.vue?vue&type=script&lang=js"
export * from "./documents-atas.vue?vue&type=script&lang=js"
import style0 from "./documents-atas.vue?vue&type=style&index=0&id=5a9684f3&prod&lang=scss&scoped=true"
import style1 from "./documents-atas.vue?vue&type=style&index=1&id=5a9684f3&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5a9684f3",
  null
  
)

export default component.exports